<template>
    <ion-header :translucent="true">
        <ion-toolbar>
            <ion-buttons slot="secondary">
                <ion-button @click="closeModal">
                    <ion-icon slot="icon-only" :icon="closeOutline"></ion-icon>
                </ion-button>
            </ion-buttons>
            <ion-title>{{ title }}</ion-title>
        </ion-toolbar>
    </ion-header>
    <ion-content fullscreen>
        <div class="read-more-popup-block">
            <span v-html="addLinksToText(description)"></span>
        </div>
    </ion-content>
</template>
  
<script>
import { IonContent, IonHeader, IonTitle, IonToolbar, IonButton, IonButtons, IonIcon, modalController, } from '@ionic/vue';
import { closeOutline, grid, list } from 'ionicons/icons';
import { defineComponent } from 'vue'
import { addLinksToText  } from '@/composables/text';

export default defineComponent({
    name: 'ReadMoreModal',
    props: {
        title: { String, default: '' },
        description: { String, default: '' },
    },
    components: {
       IonContent, IonHeader, IonTitle, IonToolbar, IonButton, IonButtons, IonIcon
    },
    setup() {
        const isDisabled = false;
        const closeModal = () => {
            modalController.dismiss();
        };
        return { closeOutline, closeModal, isDisabled, grid, list, addLinksToText }
    },
  
});

</script>
  
